import React, { useContext, useMemo, createContext, useState, useEffect } from 'react';
import { withRole } from '~/components/views/ServicesView/utils';
import { PaymentMethodName } from '~/types/PaymentMethods';
import { isMerchant } from '~/utils/getDecodedJwt';
import { getStagePayload } from '~/utils/getStagePayload';
import { isResubmit } from '~/utils/isResubmit';
import { useGetServices } from './pricing';
import { useGetApplication } from './wizard';
import { useGetCardHolder } from './cardholder';

interface CardHolderContextType {
  stepKey: string;
  updateStepKey: (stepKey: string) => void;
  updateCardHolderData: (data: any, callback?: () => void) => void;
  cardHolderData: any;
}

interface State {
  stepKey: string;
  cardHolderData: any;
}

export const CardHolderContext = createContext<CardHolderContextType>({
  stepKey: 'personalDetails',
  updateStepKey: (stepKey: string) => {},
  updateCardHolderData: (data: any, callback?: () => void) => {},
  cardHolderData: {},
});

export const useCardHolderContext = () => useContext(CardHolderContext);

export const CardHolderContextProvider = (props: any) => {
  const { children } = props;

  const { data: cardHolderData, isLoading } = useGetCardHolder();
  console.log('cardHxxxxxolderData', cardHolderData);

  const [state, setState] = useState<State>({
    stepKey: 'personalDetails',
    cardHolderData: {},
  });

  useEffect(() => {
    setState((prevState) => ({ ...prevState, cardHolderData }));
  }, [cardHolderData]);

  const contextValue = useMemo(() => {
    const updateStepKey = (stepKey: string) => {
      setState({ ...state, stepKey });
    };

    const updateCardHolderData = (cardHolderData: any, callback?: () => void) => {
      setState({ ...state, cardHolderData });
      if (callback) {
        // Call the callback after the state has been updated
        setTimeout(callback, 0);
      }
    };

    return {
      ...state,
      updateStepKey,
      updateCardHolderData,
    };
  }, [state]);

  return <CardHolderContext.Provider value={contextValue}>{children}</CardHolderContext.Provider>;
};
